var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getMangoVopStatusInfo } from "@rentiohq/shared-frontend/dist/utils/bankAccount.utils";
import styled from "styled-components";
import { Icon } from "../Icon";
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 6px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 6px;\n"])));
var Title = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n"], ["\n  color: ", ";\n  font-size: 12px;\n"])), function (props) { return props.color; });
export var VopStatusBadge = function (_a) {
    var status = _a.status;
    var statusInfo = getMangoVopStatusInfo(status);
    if (!statusInfo) {
        return null;
    }
    return (_jsxs(Wrap, { children: [_jsx(Icon, { source: "checkBadge", realColor: statusInfo.color }), _jsx(Title, { color: statusInfo.color, children: statusInfo.title })] }));
};
var templateObject_1, templateObject_2;
